import React from 'react'
import { withRouter } from 'react-router-dom';

import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import SpotlioButton from '../../Button';

import SpotlioIcon from '../../Icon';
import Dialog from '../../Dialog';
import CurrencySelector from '../../CurrencySelector';
import AddGuestModal from '../../../B2B/containers/Dashboard/Guests/Modal';

import { getCookie, deleteCookie } from '../../../utils/CookiesRetriever';
import request from '../../../utils/request';
import SalesIDRetriever from '../../../utils/SalesIDRetriever';
import history from '../../../history';
import PushHistory from '../../../utils/PushHistory';

import { setSelectedPromocode, getSelectedPromocode, getSystemSettings, setCartLength, getSessionId } from '../../../utils/SettingsRetriever';
import B2BTokenRegenerator from '../../../utils/B2BTokenRegenerator';
import B2BLogin from '../../../utils/B2BLogin';

import IntlMessage from '../../../LocaleEngine';
import LocaleAsString from '../../../LocaleEngine/LocaleAsString';

import { getItinerary as globalGetItinerary } from '../../../services/cart';

import './index.scss';

export default withRouter((props) => {
    //eslint-disable-next-line
    const [ b2bGuests, setB2BGuests ] = React.useState(null);
    const [ currentGuest, setCurrentGuest ] = React.useState(null);

    const [ searched, setSearched ] = React.useState(false);

    const [ travelAgentMenuOpen, setTravelAgentMenuOpen ] = React.useState(false);
    const [ anchorElement, setAnchorElement ] = React.useState(null);

    const [ guestsModal, setGuestsModal ] = React.useState(false);
    const [ guestsSearchCriteria, setGuestsSearchCriteria ] = React.useState("firstName");
    const [ guestsSearchPattern, setGuestsSearchPattern ] = React.useState("");
    const [ forceGuestModalSpan, setForceGuestModalSpawn ] = React.useState(false);

    const [ attachingGuest, setAttachingGuest ] = React.useState(false);

    const [ regenerateDialog, setRegenerateDialog ] = React.useState(false);
    const [ itemsInCartDialog, setItemsInCartDialog ] = React.useState(false);

    const [ showResults, setShowResults ] = React.useState(false);
    const [ showAllItems, setShowAllItems ] = React.useState(false);
    const [ displayMode, setDisplayMode ] = React.useState("search");

    const [ detachGuestConfirmModal, setDetachGuestConfirmModal ] = React.useState(false);
    const [ confirmReturnToDashboard, setConfirmReturnToDashboard ] = React.useState(false);
    const [ triggeredModalFromEvent, setTriggeredModalFromEvent ] = React.useState(false);

    const [ confirmDetachRedirectDiag, setConfirmDetachRedirectDiag ] = React.useState(false);

    document.addEventListener("triggerAttachGuestsModal", function(e) {
        setGuestsModal(true);
        setTriggeredModalFromEvent(true);
    });

    history.listen((location, type) => {
        B2BTokenRegenerator();
    });

    const travelAgentToggleModal = (event) => {
        const tamo = !travelAgentMenuOpen;
        setAnchorElement(event.currentTarget);
        setTravelAgentMenuOpen(tamo);
    }

    const getCurrentGuest = (callback = () => true) => {
        request({
            url: getSystemSettings().api + '/inntopia/travel-agent/guest/current',
            method: 'POST',
            data: {
                token: props.b2bCookie.token.token,
                salesId: SalesIDRetriever(),
            }
        }).then(response => {
            if (response.status === 200) {
                setCurrentGuest(response.data);
                if (triggeredModalFromEvent === true) PushHistory('/checkout/payment');
            }
        })
    }

    const attachGuestAction = (guestId) => {
        request({
            url: getSystemSettings().api + '/inntopia/travel-agent/guest/attach',
            method: 'POST',
            data: {
                token: props.b2bCookie.token.token,
                salesId: SalesIDRetriever(),
                guestId: guestId
            }
        }).then(response => {
            if (response.status === 200) {
                getCurrentGuest();
            }
            setAttachingGuest(false);
        })
    }

    const attachGuest = (guestId) => {
        setAttachingGuest(guestId);
        if (currentGuest) {
            dettachGuest(currentGuest.id, guestId);
        } else {
            attachGuestAction(guestId);
        }
    }

    const dettachGuest = (guestId, attachingGuest = null, forceDetach = false) => {
        const urlPrefix = getSystemSettings().urlPrefix;
        const isOnBadPath = [urlPrefix + '/checkout/payment', urlPrefix + '/checkout/review'].indexOf(window.location.pathname) >= 0;

        if (!isOnBadPath || (isOnBadPath && forceDetach)) {
            request({
                url: getSystemSettings().api + '/inntopia/travel-agent/guest/remove',
                method: 'POST',
                data: {
                    token: props.b2bCookie.token.token,
                    salesId: SalesIDRetriever(),
                    guestId: guestId
                }
            }).then(response => {
                if (response.status === 200) {
                    setCurrentGuest(null);
                    setDisplayMode("search");
                    setShowAllItems(false);
                    setGuestsSearchPattern("");
                    setGuestsSearchCriteria("firstName");
                    setDetachGuestConfirmModal(false);
                    getCurrentGuest();
                    if (attachingGuest) {
                        attachGuestAction(attachingGuest);
                    }
                    if (isOnBadPath) {
                        PushHistory('/shopping-cart/review');
                    }
                } else {
                    setItemsInCartDialog(true);
                }
            })
        } else {
            setConfirmDetachRedirectDiag(true);
        }
    }

    const handleLogout = () => {
        deleteCookie('b2b');
        deleteCookie('b2bagent');
        deleteCookie('b2btato');
        setSelectedPromocode('');
        PushHistory('/b2b');
    }

    const handleClearSearch = () => {
        setGuestsSearchPattern("");
        setGuestsSearchCriteria("firstName");
        setShowResults(false);
        setDisplayMode("search");
        handleSearch(true);
    }

    const handleSearch = (flag = false) => {
        let doNotSearch = false;
        let currentGuest = null;
        if (typeof(flag) === 'object') {
            const data = flag;
            currentGuest = data.guestId;
        } else {
            doNotSearch = flag;
        }
        let data = {
            token: props.b2bCookie.token.token,
            salesId: SalesIDRetriever()
        };
        if (guestsSearchPattern !== "" && !doNotSearch) {
            data[guestsSearchCriteria] = guestsSearchPattern;
        }

        // if (!guestsSearchPattern) return null;

        request({
            url: getSystemSettings().api + '/inntopia/travel-agent/guest/search',
            method: 'POST',
            data: data
        }).then(guests => {
            if (guests.status === 200) {
                setB2BGuests(guests.data)
                setDisplayMode(data[guestsSearchCriteria] ? "show" : "search");
                setShowResults(true);
                if (currentGuest) {
                    guests.data.forEach(idx => {
                        if (idx.id === currentGuest) {
                            attachGuest(currentGuest);
                        }
                    })
                }
            } else {
                setB2BGuests([])
            }
        });
    }

    const b2bCookie = JSON.parse(getCookie('b2b') || '{}');
    if (b2bCookie.channel && !searched) {
        setSearched(true);
        if (window.location.pathname.indexOf('/checkout/completed') < 0) getCurrentGuest();
        handleSearch();
    }

    const toggleGuestsModal = () =>{
        if (guestsModal === true){
            setGuestsModal(false);
        } else {
            setGuestsModal(true)
            setTriggeredModalFromEvent(false);
        }
    }

    const currentGuestButton = (
        currentGuest ? (
            <div className="avatar Guest" onClick={() => toggleGuestsModal()}>
                {currentGuest.firstName + ' ' + currentGuest.lastName}
            </div>
        ) : (
            <Avatar className="avatar" onClick={() => toggleGuestsModal()}>
                <SpotlioIcon icon="va-account_loggedout" />
            </Avatar>
        )
    );

    const goToDashboard = (removeSession = false) => {
        const redirect = () => {
            setSelectedPromocode('');
            PushHistory('/b2b/dashboard');
        }
        if (removeSession) {
            regenerateSession(redirect);
        } else redirect();
    }

    const reviewReturnToDashboard = () => {
        const System = getSystemSettings();
        if (System.b2b && System.b2b.allowMultiplePackages === false) {
            globalGetItinerary({
                id: System.id,
                sessionId: getSessionId(),
                salesId: SalesIDRetriever()
            }).then(response => {
                let triggered = false;
                if (response.items.length === 0) {
                    goToDashboard();
                } else {
                    response.items.forEach((item, idx) => {
                        item.items.forEach((pkgItem, jdx) => {
                            if (pkgItem.PackageId === getSelectedPromocode().inntopiaPackageId) {
                                setConfirmReturnToDashboard(true);
                                triggered = true;
                            }
                            if (idx === (response.items.length - 1)) {
                                if (!triggered) {
                                    goToDashboard();
                                }
                            }
                        });
                    });
                }
            })
        } else {
            goToDashboard();
        }
    }

    const regenerateSession = (callback = goToDashboard) => {
        setRegenerateDialog(true);
        request({
            url: getSystemSettings().api + '/b2b/travelagentchannel/listChannelsForTravelAgentUsername?username=' + b2bCookie.authDetails.user + '&resortId=' + getSystemSettings().b2b.resortId,
            method: 'GET'
        }).then(response => {
            setCartLength(0);
            response.data.forEach(channel => {
                if (channel.inntopiaChannelSalesId === b2bCookie.channel) {
                    B2BLogin(b2bCookie.authDetails.user, b2bCookie.authDetails.password, channel, () => {
                        setRegenerateDialog(false);
                        setCurrentGuest(null);
                        setItemsInCartDialog(false);
                        callback();
                    }, () => {
                        setRegenerateDialog(false);
                        setCurrentGuest(null);
                        setItemsInCartDialog(false);
                        callback();
                    });
                }
            })
        })
    }

    const saveItinerary = () => {
        request({
            url: getSystemSettings().api + '/inntopia/cart/save',
            method: 'POST',
            data: {
                sessionId: getSessionId(),
                salesId: SalesIDRetriever()
            }
        }).then(response => {
            regenerateSession();
        })
    }

    let detailsCookie = JSON.parse(getCookie('b2bagent'));
    if (!detailsCookie) detailsCookie = {name: LocaleAsString('b2b.booking.travel_agent')};
    // let agentName = detailsCookie.name.split(' ')[0].substring(0, 1) + (detailsCookie.name.split(' ').length > 1 ? detailsCookie.name.split(' ')[1].substring(0, 1) : '');
    let agentName = detailsCookie.name

    return (
        <React.Fragment>
            <div className="HeaderWrapper">
                <div className="SwitchesWrapper">
                    <div className="TopBarSwitches">
                        <Button onClick={() => reviewReturnToDashboard()}><IntlMessage id="b2b.header.buttons.dashboard" /></Button>
                        { JSON.parse(getCookie('b2b'))['hideTopbarSwitch'] === false ? (
                                <Button className="selected"><IntlMessage id="b2b.header.buttons.booking" /></Button>
                        ) : ''
                        }
                    </div>
                </div>
                <div className="tatoButtons">
                    <div className="tatoButton" >
                        <div className="avatar Guest" onClick={(e) => travelAgentToggleModal(e)}>
                            { agentName }
                        </div>
                    </div>
                    <div className="tatoButton">
                        {
                            currentGuest
                            ? currentGuestButton
                            : (
                                <Badge className="NoGuest" badgeContent="!">
                                    { currentGuestButton }
                                </Badge>
                            )
                        }
                    </div>
                    <div onClick={props.onCartTrigger} className="tatoButton">
                        {/* <Link to={getSystemSettings().urlPrefix + "/cart"}> */}
                            {/* <Badge className="CartItems" badgeContent={getCartLength() === false ? "0" : props.cartLength} color="primary"> */}
                                <Avatar className="avatar" >
                                    <SpotlioIcon icon="sp2-shopping-cart" />
                                </Avatar>
                            {/* </Badge> */}
                        {/* </Link> */}
                    </div>
                    <div className="tatoButton">
                        <CurrencySelector className="avatar" mode="b2b" />
                    </div>
                </div>
            </div>
            <Menu
                style={{marginTop: '3em'}}
                id="travelAgentMenu"
                className="tatoFloatingMenu"
                anchorEl={anchorElement}
                keepMounted
                open={travelAgentMenuOpen}
                onClose={() => setTravelAgentMenuOpen(false)}
            >
                <MenuItem className="floatingMenuItem" onClick={() => reviewReturnToDashboard()}>
                    <IntlMessage id="b2b.travel_agent.go_to_dashboard" />
                </MenuItem>
                {
                    getSystemSettings().b2b.conditions
                    ?
                    getSystemSettings().b2b.conditions.map((item, index) => {
                        return (
                        <MenuItem key={'conditions_lnk_'+index} className="floatingMenuItem">
                            <a rel="noopener noreferrer" target="_blank" href={item.link}>
                                {item.text}
                            </a>
                        </MenuItem>
                        )
                    })
                    : null
                }
                <MenuItem className="floatingMenuItem" onClick={() => regenerateSession()}>
                    <IntlMessage id="b2b.travel_agent.regenerate_session" />
                </MenuItem>
                <MenuItem className="floatingMenuItem" onClick={() => handleLogout()}>
                    <IntlMessage id="b2b.travel_agent.logout" />
                </MenuItem>
            </Menu>
            <Dialog
                open={guestsModal}
                container={() => document.getElementsByClassName('main-application')[0]}
                closeFn={() => toggleGuestsModal(false)}
                title="Attach a Guest"
                className="attachGuest"
                withCloseButton
                size="lg"
                footerContent={
                    <React.Fragment />
                }
            >
                <div className="body">
                    <div className="currentGuest">
                        <div className="guestDetails">
                        {
                            currentGuest ? (
                                <React.Fragment>
                                    <h3>Current Guest: <span>{currentGuest.id + " - " + currentGuest.firstName + " " + currentGuest.lastName + " (" + currentGuest.country + ")"}</span></h3>
                                    <Button className="detachGuest" onClick={() => setDetachGuestConfirmModal(true)}>
                                        Detach
                                    </Button>
                                </React.Fragment>
                            ) : (
                                <h3 className="noGuest">No guest attached</h3>
                            )
                        }
                        </div>
                    </div>
                    <div className="guestsList">
                        {
                            currentGuest ? (
                                <div className="guestAttached">
                                    <div className="infoWrapper">
                                        <p>Guest has been attached successfully. To see the guests list, please detach the current guest.</p>
                                    </div>
                                </div>
                            ) : (
                                <React.Fragment>
                                    <div className="SearchRegion">
                                        <h3>Search by</h3>
                                        <Select className="Switch" value={guestsSearchCriteria} onChange={(e) => setGuestsSearchCriteria(e.target.value)}>
                                            <MenuItem value="firstName">First Name</MenuItem>
                                            <MenuItem value="lastName">Last Name</MenuItem>
                                            <MenuItem value="phone">Phone</MenuItem>
                                            <MenuItem value="email">Email</MenuItem>
                                        </Select>
                                        <TextField className="SearchPattern" value={guestsSearchPattern} onKeyDown={(e) => e.key === 'Enter' && handleSearch() } onChange={(e) => setGuestsSearchPattern(e.target.value)} />
                                        <div className="ButtonsRegion">
                                            <Button onClick={() => handleSearch()} className="attachButton primary">Search</Button>
                                            <Button onClick={() => handleClearSearch()} className="attachButton secondary">Clear</Button>
                                            <AddGuestModal
                                                buttonClass="attachGuestButton secondary"
                                                onClose={() => setForceGuestModalSpawn(false)}
                                                forceModalSpawn={forceGuestModalSpan}
                                                userId={null}
                                                env="b2c"
                                                onEditConfirm={(response) => handleSearch(response ? response.data : false)}
                                            />
                                        </div>
                                    </div>
                                    <React.Fragment>
                                        {
                                            displayMode === "search" && (
                                                <FormControlLabel
                                                    control={
                                                    <Checkbox
                                                        checked={showAllItems}
                                                        onChange={(e) => setShowAllItems(e.target.checked)}
                                                        value="checkedB"
                                                        color="primary"
                                                    />
                                                    }
                                                    label="Show the complete guests list"
                                                />
                                            )
                                        }
                                    </React.Fragment>
                                    <React.Fragment>
                                        {
                                            ((displayMode === "show" && showResults && b2bGuests) || (displayMode === "search" && showAllItems))&& (
                                                b2bGuests.length > 0 ? (
                                                    b2bGuests.map((val, idx) => {
                                                        return (
                                                            <div key={idx} className="guest">
                                                                <p className="guestDetails">{ val.firstName + " " + val.lastName + ' (+' + val.phoneNumber + ', ' + val.email + ')' }</p>
                                                                <SpotlioButton spinnerSize={16} loading={attachingGuest === val.id} className="attachButton" callBack={() => attachGuest(val.id)}>Attach</SpotlioButton>
                                                            </div>
                                                        )
                                                    })
                                                ) : (
                                                    <React.Fragment>
                                                        <h3>No guests found.</h3>
                                                    </React.Fragment>
                                                )
                                            )
                                        }
                                    </React.Fragment>
                                </React.Fragment>
                            )
                        }
                    </div>
                </div>
            </Dialog>
            <Dialog
                open={regenerateDialog}
                title={LocaleAsString('b2b.topbar.regenerate_session_title')}
                className="regenerateSession"
                footerContent={
                    <React.Fragment />
                }
            >
                <div className="body">
                    <CircularProgress />
                    <IntlMessage id="b2b.topbar.regenerate_session_content" />
                </div>
            </Dialog>
            <Dialog
                open={itemsInCartDialog}
                title={LocaleAsString('b2b.topbar.items_in_cart_title')}
                className="itemsInCart"
                footerContent={
                    <React.Fragment>
                        <Button onClick={() => setItemsInCartDialog(false)} className="attachButton primary">Cancel</Button>
                        <Button onClick={() => regenerateSession()} className="attachButton primary">Empty cart and detach</Button>
                        <Button onClick={() => saveItinerary()} className="attachButton primary">Save Itinerary</Button>
                    </React.Fragment>
                }
            >
                <div className="body">
                    <IntlMessage id="b2b.topbar.items_in_cart_content" />
                </div>
            </Dialog>
            <Dialog
                open={detachGuestConfirmModal}
                title={LocaleAsString('b2b.topbar.detach_guest_confirmation.title')}
                className="itemsInCart"
                footerContent={
                    <React.Fragment>
                        <Button onClick={() => dettachGuest(currentGuest.id)} className="attachButton primary">Yes</Button>
                        <Button onClick={() => setDetachGuestConfirmModal(false)} className="attachButton primary">Cancel</Button>
                    </React.Fragment>
                }
            >
                <div className="body">
                    <IntlMessage id="b2b.topbar.detach_guest_confirmation.content" />
                </div>
            </Dialog>
            <Dialog
                open={confirmReturnToDashboard}
                title={LocaleAsString('b2b.topbar.return_to_dashboard.title')}
                className="itemsInCart"
                footerContent={
                    <React.Fragment>
                        <Button onClick={() => goToDashboard(true)} className="attachButton primary">Yes</Button>
                        <Button onClick={() => setConfirmReturnToDashboard(false)} className="attachButton primary">Cancel</Button>
                    </React.Fragment>
                }
            >
                <div className="body">
                    <IntlMessage id="b2b.topbar.return_to_dashboard.content" />
                </div>
            </Dialog>
            <Dialog
                open={confirmDetachRedirectDiag}
                title={LocaleAsString('b2b.topbar.detach_redirect_to_cart_diag.title')}
                className="itemsInCart"
                footerContent={
                    <React.Fragment>
                        <Button onClick={() => dettachGuest(currentGuest.id, null, true)} className="attachButton primary">Yes</Button>
                        <Button onClick={() => setConfirmDetachRedirectDiag(false)} className="attachButton primary">Cancel</Button>
                    </React.Fragment>
                }
            >
                <div className="body">
                    <IntlMessage id="b2b.topbar.detach_redirect_to_cart_diag.content" />
                </div>
            </Dialog>
        </React.Fragment>
    )
})
